// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import ReportsView from "../../components/rgsICU/reports";

const Reports = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <ReportsView />
    </Main>
  </>
);

export default Reports;
